<p-floatlabel variant="in" class="input-field">
  <p-datepicker
    [formControl]="control"
    [iconDisplay]="'input'"
    [showIcon]="true"
    inputId="date_picker"
    [fluid]="true"
    [class.ng-invalid]="control.invalid && control.touched"
    [class.ng-dirty]="control.touched"
  />
  <label for="date_picker">{{ label }}</label>
</p-floatlabel>

@if (control.invalid && control.touched) {
  <small class="input-field-error">{{ errorMessage ?? 'This field is required' }}</small>
}
